export default __webpack_public_path__ + "05849fa77b9dff365c10092b56e3a1dd.png";